const arduino = [
    {
        id: 1,
        title : 'arduino',
        img : 'image/arduino.png',
        playlist: 'https://www.youtube.com/embed?v=4IOTECCBgB8&list=PLp7oKpMpk8gSwLnJ3QJGfDBB1GitNEw7K'
    },

    {
        id: 2,
        title : 'arduino',
        img : 'image/arduino.png',
        playlist: 'https://www.youtube.com/embed?v=P-zfssjfae4&list=PLy_HldhW2XY9z3TcfKVOHhDwb04aNB3iM'
    },

    {
        id: 3,
        title : 'چەند پڕۆژەیەک',
        img : 'image/arduino.png',
        playlist: 'https://www.youtube.com/embed?v=DTezLdwdAXU&list=PLZURamUG6JwgsvMPSXIDym2Xr9f0KkBNI&index=1'
    }
]

export default arduino;